// Sign-in page
import { useState } from '../core/react.js';
import { useNarrow } from '../ui/narrow.js';
import { T } from '../core/theme.js';
import { Icon } from '../ui/icons.js';
import { TwoFactorStep } from '../pages/security.js';

export function Login({
  onLogin,
  initialEmail
}) {
  const [email, setEmail] = useState(initialEmail || '');
  const [pw, setPw] = useState('');
  const [err, setErr] = useState('');
  const narrow = useNarrow();   // phones: a short brand header above the form, and the page scrolls
  const [step, setStep] = useState(null);   // {stage, user} after a correct password when two-factor is needed
  async function attempt() {
    if (!email.trim()) {
      setErr('Enter your email.');
      setTimeout(() => setErr(''), 3000);
      return;
    }
    if (!pw) {
      setErr('Enter your password.');
      setTimeout(() => setErr(''), 3000);
      return;
    }
    try {
      const r = await window.PrismAPI.call('login', {
        email: email.trim(),
        password: pw
      });
      if (r.stage && r.stage !== 'full') { setPw(''); setStep({ stage: r.stage, user: r.user }); return; }
      onLogin(r.user);
    } catch (e) {
      setErr(e.message || 'Sign-in failed.');
      setTimeout(() => setErr(''), 5000);
    }
  }
  if (step) return React.createElement(TwoFactorStep, { stage: step.stage, user: step.user, onDone: u => onLogin(u), onCancel: () => { window.PrismAPI.call('logout').catch(() => {}); setStep(null); } });
  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: narrow ? 'column' : 'row',
      height: narrow ? '100dvh' : '100vh',
      overflowY: narrow ? 'auto' : 'visible',
      fontFamily: "'Open Sans',system-ui,sans-serif"
    }
  }, React.createElement("div", {
    style: {
      width: narrow ? 'auto' : 460,
      background: T.navy,
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: narrow ? 18 : 0,
      padding: narrow ? '26px 24px 24px' : '52px 52px 44px',
      flexShrink: 0
    }
  }, React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      opacity: .035,
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
      backgroundSize: '180px'
    }
  }), React.createElement("div", {
    style: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: 300,
      background: 'radial-gradient(ellipse at 0% 100%, rgba(128,130,133,.35) 0%, transparent 70%)',
      pointerEvents: 'none'
    }
  }), React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, React.createElement("img", {
    src: "./img/login-mark.png",
    alt: "glassbox",
    style: {
      height: narrow ? 56 : 96,
      width: 'auto',
      display: 'block'
    }
  }), React.createElement("div", {
    style: {
      marginTop: 10,
      fontSize: 12,
      fontWeight: 600,
      letterSpacing: '0.36em',
      color: 'rgba(255,255,255,.7)',
      fontFamily: "'Open Sans',system-ui,sans-serif"
    }
  }, "PRISM")), React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, React.createElement("div", {
    style: {
      fontSize: narrow ? 26 : 44,
      fontWeight: 300,
      color: T.white,
      lineHeight: 1.15,
      letterSpacing: '-0.03em',
      marginBottom: narrow ? 0 : 28,
      fontFamily: "'Open Sans',system-ui,sans-serif"
    }
  }, "Elite events.", React.createElement("br", null), "Precise numbers."), !narrow && React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 14
    }
  }, [
    ['Budgets in any currency', 'Cost and billing currencies, branded client estimates'],
    ['Costs read by Claude', 'Invoices, receipts and quotes straight into the budget'],
    ['Schedules and crew', 'Run of show, people, travel and deliveries'],
    ['Tenders and suppliers', 'Briefs, quote comparison and one supplier directory'],
    ['Secure by design', 'Two-factor sign-in, encrypted backups, GDPR tools']
  ].map(([h, s]) => React.createElement("div", {
    key: h,
    style: {
      display: 'flex',
      gap: 12,
      alignItems: 'flex-start'
    }
  }, React.createElement("span", {
    style: {
      marginTop: 4,
      flexShrink: 0
    }
  }, React.createElement(Icon.check, {
    s: 11
  })), React.createElement("div", null, React.createElement("div", {
    style: {
      fontSize: 13,
      fontWeight: 600,
      color: T.white
    }
  }, h), React.createElement("div", {
    style: {
      fontSize: 11,
      color: 'rgba(255,255,255,.4)',
      marginTop: 1
    }
  }, s)))))), !narrow && React.createElement("div", {
    style: {
      position: 'relative',
      fontSize: 10,
      color: 'rgba(255,255,255,.18)',
      letterSpacing: '0.12em'
    }
  }, "CONFIDENTIAL \xB7 INTERNAL USE ONLY")), React.createElement("div", {
    style: {
      flex: narrow ? '1 0 auto' : 1,
      background: T.ivory,
      display: 'flex',
      alignItems: narrow ? 'flex-start' : 'center',
      justifyContent: 'center',
      padding: narrow ? '28px 20px 40px' : 0,
      position: 'relative'
    }
  }, React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      backgroundImage: `radial-gradient(circle at 70% 20%, rgba(62,63,67,.04) 0%, transparent 60%)`
    }
  }), React.createElement("div", {
    style: {
      width: 360,
      maxWidth: '100%',
      position: 'relative'
    },
    className: "fade-up"
  }, React.createElement("img", {
    src: "./img/login-wordmark.png",
    alt: "glassbox",
    className: 'phone-hide',   // the brand header above already shows it on phones
    style: {
      height: 30,
      width: 'auto',
      display: 'block',
      marginBottom: '28px'
    }
  }), React.createElement("div", {
    style: {
      fontSize: 28,
      fontWeight: 600,
      color: T.coal,
      marginBottom: 6,
      letterSpacing: '-0.02em'
    }
  }, "Sign in"), React.createElement("div", {
    style: {
      fontSize: 14,
      color: T.mist,
      marginBottom: 36
    }
  }, "Glassbox Prism \xB7 budgets, costs, schedules, crew and suppliers"), [['EMAIL', email, setEmail, 'email'], ['PASSWORD', pw, setPw, 'password']].map(([lbl, val, set, type]) => React.createElement("div", {
    key: lbl,
    style: {
      marginBottom: 20
    }
  }, React.createElement("div", {
    style: {
      fontSize: 10,
      fontWeight: 700,
      letterSpacing: '0.1em',
      color: T.slate,
      marginBottom: 7
    }
  }, lbl), React.createElement("input", {
    value: val,
    onChange: e => set(e.target.value),
    type: type,
    'aria-label': type === 'email' ? 'Email' : 'Password',
    autoComplete: type === 'email' ? 'username' : 'current-password',
    placeholder: type === 'password' ? '············' : undefined,
    onKeyDown: e => e.key === 'Enter' && attempt(),
    style: {
      width: '100%',
      padding: '11px 14px',
      background: T.white,
      border: `1px solid ${err && type === 'email' ? T.red : T.rule}`,
      fontSize: 14,
      color: T.coal,
      borderRadius: 0,
      transition: 'border-color .15s',
      fontFamily: "'Open Sans',system-ui,sans-serif"
    }
  }))), err && React.createElement("div", {
    style: {
      fontSize: 12,
      color: T.red,
      marginBottom: 12
    }
  }, err), React.createElement("button", {
    onClick: attempt,
    style: {
      width: '100%',
      padding: '13px',
      background: T.navy,
      color: T.white,
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: '0.12em',
      borderRadius: 0,
      transition: 'filter .15s'
    },
    onMouseEnter: e => e.target.style.filter = 'brightness(1.12)',
    onMouseLeave: e => e.target.style.filter = ''
  }, "SIGN IN"))));
}
